import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
interface BackButtonProps {
  label?: string;
  to?: string;
  className?: string;
  onClick?: () => void;
}
const BackButton: React.FC<BackButtonProps> = ({
  label = 'Back',
  to,
  className = '',
  onClick
}) => {
  const navigate = useNavigate();
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
      return;
    }
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };
  return <button onClick={handleClick} className={`inline-flex items-center text-sm font-medium ${dk.textSecondary} ${rt.accentLink} transition-colors group ${className}`} aria-label={label} data-id="element-3665" data-mp="3jzsnoot85lli">
      <ArrowLeftIcon className="w-4 h-4 mr-1 transition-transform group-hover:-translate-x-1" data-id="element-3666" data-mp="3aze1zoccm4hh" />
      {label}
    </button>;
};
export default BackButton;